export default [
    {
        path: '/customer/dialogue',
        props: true,
        component: () => import('@/views/Customer/Dialogue'),
    },
    {
        path: '/customer/dialogue/:dossierId',
        props: true,
        component: () => import('@/views/Customer/Dialogue/Show.vue'),
        meta: {
            activates: '/customer/dialogue',
        }
    },
];
